import type { Phrase } from '../types';

/** Strings for the explore area of the public site. Every key starts with `ex`. */
export const exploreEn = {
  // header + top search bar
  exEyebrow: 'Explore venues',
  exLead: 'Search verified venues by place, date, event and guest count, compare two side by side and send a request.',
  exSearchLabel: 'Venue, area or city',
  exLocation: 'Location',
  exAnyLocation: 'Any location',
  exDate: 'Date',
  exEventType: 'Event type',
  exAnyEvent: 'Any event',
  exOccasionAll: '{name} (all kinds)',
  exGuestsPlaceholder: 'How many?',
  exGuestCount: 'Number of guests',
  exGuestCountHint: 'Shows venues that can hold this many guests (seated plus standing).',
  exGuestsRule: 'Number of guests must be a whole number, 1 or more',
  exClearDate: 'Clear date',

  // filters
  exFilters: 'Filters',
  exFiltersTitle: 'Filter venues',
  exVenueType: 'Venue type',
  exMaxPrice: 'Max price per hour (₹)',
  exFacilities: 'Facilities',
  exAc: 'Air-conditioned',
  exNonAc: 'Non-AC only',
  exMinRating: 'Guest rating',
  exRatingAny: 'Any',
  exRatingN: '{n}+',
  exRatingHint: 'Only venues with reviews are counted.',
  exSaved: 'Saved venues only',
  exSavedHint: { one: '{count} venue saved in this browser', other: '{count} venues saved in this browser' },
  exClose: 'Close filters',
  exClearAll: 'Clear all',
  exShowResults: 'Show venues',

  // active filter chips
  exActiveFilters: 'Active filters',
  exRemoveChip: 'Remove filter: {label}',
  exChipSearch: '“{text}”',
  exChipGuests: 'Fits {count} guests',
  exChipMaxPrice: 'Up to {price} / hour',
  exChipRating: '{n}★ and up',
  exChipDate: 'Free on {date}',
  exChipSaved: 'Saved only',

  // results
  exSortLabel: 'Sort by',
  exSortRecommended: 'Recommended',
  exSortRating: 'Highest rated',
  exSortReviews: 'Most reviewed',
  exSortCapacity: 'Largest capacity',
  exView: 'Layout',
  exViewGrid: 'Grid view',
  exViewList: 'List view',
  exUpdating: 'Updating results…',
  exErrorBody: 'Check your internet connection and try again.',
  exRetry: 'Try again',
  exEmptyTitle: 'No venues found',
  exEmptyBody: 'No venue matches your search. Try another location or date, or remove a filter.',
  exEmptySavedBody: 'You haven’t saved any venues yet. Tap the heart on a venue to keep it here.',
  exNoVenuesTitle: 'No venues listed yet',
  exNoVenuesBody: 'Venues appear here once they are verified. Please check back soon.',

  // helper strip
  exHelpTitle: 'Can’t decide?',
  exHelpBody: 'Browse venues by occasion, pick up planning ideas, or tell us what you need and we will help you choose.',
  exHelpOccasions: 'Browse by occasion',
  exHelpInspiration: 'Get inspired',
  exHelpContact: 'Talk to us',

  // night edition
  exCrumbs: 'Breadcrumb',
  exCrumbHome: 'Home',
  exTitleLead: 'Find your',
  exTitleAccent: 'venue',
  exResultsWord: { one: 'venue available', other: 'venues available' },
  exNoMatch: 'No venues match these filters yet.',
  exFavSaved: '{name} saved',
  exFavRemoved: 'Removed from saved',
  exCompareTray: 'Compare venues',
  exCompareReady: '2 venues selected',
  exCompareClear: 'Clear the comparison',
  exCmpTitle: 'Side by side',
  exCmpBetter: 'Better on this',
} satisfies Record<string, Phrase>;
